<div>
    <input
    [formControl]="inputFormControl"
    nbInput
    type="text"
    placeholder="查詢員工"        
    [(ngModel)]="value"
    (ngModelChange)="onModelChange($event)"
    (blur)="onBlur()"
    (click)="onClick()"
    [nbAutocomplete]="auto"/>

    <nb-autocomplete #auto>

        <nb-option-group *ngFor="let group of filteredGroups$ | async; "  
            [title]="group.name" >
            <nb-option *ngFor="let op of group.child" 
                [value]="op.content" 
                (click)="onSelect(op)">
                {{ op.content }}
            </nb-option>
        </nb-option-group>

    </nb-autocomplete>

    
</div>